<template>

  <a-card :bordered="false" :title="$t('app.service.serviceInfo')">
    <a-list
      itemLayout="horizontal"
      :dataSource="data"
    >
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{ item.description }}</span>
            <span v-if="item.value"> : </span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
        </template>

      </a-list-item>
    </a-list>
    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>
    <pay-password-modal ref="paypasswordmodal" @ok="passwordModalOk"></pay-password-modal>
  </a-card>
</template>

<script>
  import PasswordModal from './PasswordModal'
  import PayPasswordModal from './PayPasswordModal'
  import {getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {ListMixin} from '@/mixins/ListMixin'

export default {
  components: {
    PasswordModal,
    PayPasswordModal
  },
  data () {
    return {
      data: [
        { title: 'Login PassWord', description: 'The password used for account login, more than 8 digits, composed of letters, numbers, and symbols. And it is not the same as the payment password.', actions: { title: 'modify', callback: () => { this.handleChangePassword() } } },
        { title: 'Payment PassWord', description: 'Very important! Involving sensitive operations such as funds or permissions, we will need to verify the payment password. More than 8 characters, composed of letters, numbers, and symbols, and not the same as the login password.', actions: { title: 'modify', callback: () => { this.handleChangePayPassword() } } },
      ]
    }
  },
  methods: {
    handleChangePassword() {
      this.$refs.passwordmodal.show();
    },
    handleChangePayPassword() {
      this.$refs.paypasswordmodal.show();
    },
    passwordModalOk() {
      //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    }
  }
}
</script>

<style scoped>

</style>
